import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { SidebarProvider, SidebarInset, SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { CrmKruimels } from './CrmKruimels';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useAuth } from '@/hooks/useAuth';
import { useNotifications } from '@/contexts/NotificationContext';
import { useModuleSettings } from '@/hooks/useModuleSettings';
import { Bell, Settings } from 'lucide-react';
import { CRMChatbot } from '@/components/crm/CRMChatbot';
import { PWAInstallPrompt } from './PWAInstallPrompt';
import { GlobalCommand } from '@/components/GlobalCommand';

export const CRMLayout = () => {
  const { userRole } = useAuth();
  const { unreadCount } = useNotifications();
  const { isModuleEnabled } = useModuleSettings();
  const isAdmin = userRole === 'admin' || userRole === 'super_admin';
  const location = useLocation();

  return (
    <SidebarProvider>
      <div className="flex h-svh w-full overflow-hidden">
        <AppSidebar />
        
        <SidebarInset className="flex flex-col h-full overflow-hidden">
          <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4 bg-background z-20">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <CrmKruimels />
            
            {/* Command Palette, notificatiebel & Settings */}
            <div className="ml-auto flex items-center gap-2">
              <GlobalCommand />
              {/* T1.6: de notificatiepagina is uit de sidebar; de bel woont hier.
                  De module-schakelaar die het sidebar-item had, geldt hier ook. */}
              {isModuleEnabled('notifications') && (
              <Button variant="ghost" size="sm" asChild className="relative">
                <NavLink
                  to="/crm/notifications"
                  aria-label={unreadCount > 0 ? `Notificaties, ${unreadCount} ongelezen` : 'Notificaties'}
                >
                  <Bell className="h-4 w-4" />
                  {unreadCount > 0 && (
                    <Badge
                      variant="default"
                      className="absolute -right-1 -top-1 h-4 min-w-4 justify-center px-1 text-[10px] leading-none"
                    >
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </Badge>
                  )}
                </NavLink>
              </Button>
              )}
              {isAdmin && (
                <Button variant="ghost" size="sm" asChild>
                  <NavLink to="/crm/settings" className="flex items-center gap-2">
                    <Settings className="h-4 w-4" />
                    <span className="hidden sm:inline">Instellingen</span>
                  </NavLink>
                </Button>
              )}
            </div>
          </header>
          <main className="flex-1 overflow-auto overflow-x-hidden">
            {location.pathname === '/crm/intelligence' ? (
              <div className="h-full w-full">
                <Outlet />
              </div>
            ) : (
              /* overflow-x-clip, niet -hidden: hidden maakt van deze div een eigen
                 scrollcontainer, en dan blijft niets eronder sticky (de sectiebalk van
                 de projectpagina). Clip knipt net zo af zonder dat bijeffect. */
              <div className="p-3 sm:p-6 w-full max-w-full overflow-x-clip">
                <Outlet />
              </div>
            )}
          </main>
          <CRMChatbot />
        </SidebarInset>
      </div>
      <PWAInstallPrompt />
    </SidebarProvider>
  );
};
